import { defineAsyncComponent, defineComponent, getCurrentInstance, h } from 'vue';

import { resolveEducationApi } from './api/educationApi';
import { validateEducationHostContract } from './host/educationModuleContract';
import {
  createEducationModuleContext,
  provideEducationModuleContext,
} from './host/educationModuleContext';
import { educationI18nMessages } from './locales';
import educationStoreModule, { educationStoreModuleName } from './store/educationStore';

const EducationRouteView = defineAsyncComponent(() => import('./Education.vue'));

function createEducationRouteComponent(context) {
  return defineComponent({
    name: 'EducationModuleRoute',
    setup() {
      const store = getCurrentInstance()?.proxy?.$store || null;
      const routeContext = store
        ? {
          ...context,
          store,
        }
        : context;

      provideEducationModuleContext(routeContext);

      return () => h(EducationRouteView);
    },
  });
}

function createEducationRoutes(context) {
  return [
    {
      path: 'education',
      name: 'education',
      component: createEducationRouteComponent(context),
      meta: {
        requiresAuth: true,
        icon: 'graduation-cap',
        menuItems: 'leftSideMenu.education',
        moduleKey: 'education',
        moduleDefaultEnabled: true,
      },
      children: [],
    },
  ];
}

const menuItems = [
  {
    routeName: 'education',
    text: 'leftSideMenu.education',
    icon: 'graduation-cap',
    alwaysVisible: true,
    place: 'top',
    paths: ['/education'],
    moduleKey: 'education',
  },
];

export function createEducationModule({ host } = {}) {
  validateEducationHostContract(host);
  host.registerI18nMessages(educationI18nMessages);

  const context = createEducationModuleContext({
    educationApi: resolveEducationApi(host),
    host,
  });

  return {
    key: 'education',
    defaultEnabled: true,
    routes: createEducationRoutes(context),
    menuItems,
    storeModules: {
      [educationStoreModuleName]: educationStoreModule,
    },
    context,
    host,
  };
}
